module.exports = __webpack_public_path__ + "fde5a6cf519967b261bd9be00c7e10b3.png";